import Cookies from "../Cookies/Cookies"

export default Cookies;